var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHumanActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4317_251532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 3.33398C29.1159 3.33398 28.268 3.68517 27.6429 4.31029C27.0178 4.93542 26.6666 5.78326 26.6666 6.66732C26.6666 7.55137 27.0178 8.39922 27.6429 9.02434C28.268 9.64946 29.1159 10.0007 29.9999 10.0007C30.884 10.0007 31.7318 9.64946 32.3569 9.02434C32.9821 8.39922 33.3333 7.55137 33.3333 6.66732C33.3333 5.78326 32.9821 4.93542 32.3569 4.31029C31.7318 3.68517 30.884 3.33398 29.9999 3.33398ZM31.2249 16.6673L32.7766 26.6673H27.1733L28.5949 16.6673H31.2249ZM31.2249 13.334H28.5949C26.9349 13.334 25.5283 14.5557 25.2949 16.199L23.3333 30.0007H36.6666L34.5199 16.1573C34.2683 14.5323 32.8699 13.334 31.2249 13.334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 28.334H35V36.6673H31.6667V28.334ZM25 28.334H28.3333V36.6673H25V28.334ZM10 3.33398C9.11595 3.33398 8.2681 3.68517 7.64298 4.31029C7.01786 4.93542 6.66667 5.78326 6.66667 6.66732C6.66667 7.55137 7.01786 8.39922 7.64298 9.02434C8.2681 9.64946 9.11595 10.0007 10 10.0007C10.8841 10.0007 11.7319 9.64946 12.357 9.02434C12.9821 8.39922 13.3333 7.55137 13.3333 6.66732C13.3333 5.78326 12.9821 4.93542 12.357 4.31029C11.7319 3.68517 10.8841 3.33398 10 3.33398ZM5 16.6673V26.6673H15V16.6673C15 14.8257 13.5083 13.334 11.6667 13.334H8.33333C6.49167 13.334 5 14.8257 5 16.6673ZM8.33333 16.6673H11.6667V23.334H8.33333V16.6673Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 24.9983H8.33333V36.665H5V24.9983ZM11.6667 24.9983H15V36.665H11.6667V24.9983ZM14.035 14.3183L20 20.285L26.2617 14.3066L27.725 17.845L20 25.285L12.5717 17.8566L14.035 14.3183Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4317_251532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHumanActive);
export default __webpack_public_path__ + "static/media/ic-human-active.fbcd65dc.svg";
export { ForwardRef as ReactComponent };